module.exports = __webpack_public_path__ + "static/media/ladybug.d819e1d4.png";